import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";
import { useAdvanceSearchContext } from "../AdvanceSearchContext";
import { DropDownMultiCheck } from "../DropDownMultiCheck";

export default function Zones(params) {
  const { searchObject, setSearchObject, t } = useAdvanceSearchContext();
  const [zones, setZones] = useState([]);

  useEffect(
    () => CommonService.getAllAddressZone().then((data) => setZones(data)),
    []
  );
  function setSelectedZones(list) {
    setSearchObject({ ...searchObject, zones: list });
  }
  return (
    <fieldset>
      <legend>{t("Zone")}</legend>

      <DropDownMultiCheck
        dataList={zones}
        selecteds={searchObject.zones}
        setSelecteds={setSelectedZones}
      />
    </fieldset>
  );
}
